import {
  Box,
  Collapse,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { CSSProperties, useState } from "react";
import { AppTheme } from "../context/MainContextProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

export function RopMenuAccordion(props: {
  theme: AppTheme;
  children: React.ReactNode;
  title: string;
  icon: (style: CSSProperties) => React.ReactNode;
}) {
  const { theme, children, icon, title } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const iconStyle: CSSProperties = {
    color: isOpen ? theme.primaryTextColor : "#8F969E",
    width: "1.5rem",
    height: "1.5rem",
  };

  return (
    <>
      <ListItem disablePadding>
        <ListItemButton
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <Box className="pe-2">{icon(iconStyle)}</Box>
          <ListItemText
            primaryTypographyProps={{
              sx: {
                fontSize: "1.125rem",
              },
            }}
            sx={{
              color: isOpen ? theme.primaryTextColor : "#8F969E",
            }}
            primary={title}
          />
          <Box className="pe-2">
            <FontAwesomeIcon
              size="sm"
              icon={faAngleRight}
              style={{
                transform: isOpen ? "rotate(90deg)" : "",
                transition: "all 0.2s linear",
                color: isOpen ? theme.primaryTextColor : "#454C52",
              }}
              rotate={"90deg"}
            />
          </Box>
        </ListItemButton>
      </ListItem>

      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <Box className="d-flex flex-row justify-content-around flex-wrap">
          {children}
        </Box>
      </Collapse>
      <Divider
        sx={{
          backgroundColor: theme.secondaryTextColor,
        }}
      />
    </>
  );
}
